import './styles.scss';

import { Icon, Link } from '@ets-global/b2c-website-ui';
import { Map } from 'immutable';
import { bool, instanceOf } from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Address from '../../../Base/Address';
import BaseModal from '../../../Base/Modal/BaseModal';
import LocationTitle from '../../../Base/Title/LocationTitle';
import { useDateToString } from '../../../Element/DateToString';
import AccountSessionDesc from '../Desc';
import AccountSessionTitle from '../Title';

const SessionHeading = ({ session, past }) => {
  const { t } = useTranslation();
  const DateToString = useDateToString();
  const [isModalOpened, setIsModalOpened] = useState(false);

  return (
    <div className="account-session-heading">
      <div>
        <div className="account-session-heading__date">
          <DateToString date={session.get('scheduledAt')} timezone={session.get('timeZone')} format="DD MMM" />
          <span>
            <DateToString date={session.get('scheduledAt')} timezone={session.get('timeZone')} format="LT" />
          </span>
        </div>
        {session.get('testTypeFamily') && (
          <AccountSessionTitle
            color={session.get('testTypeFamily').get('color')}
            title={session.get('testTypeFamily').get('name')}
            testTypeProgram={session.get('testType').get('program')}
            testTypeFormat={session.getIn(['testType', 'format'])}
          />
        )}
      </div>
      {session.get('testTypeFamily') && (
        <AccountSessionDesc
          program={session.get('testType').get('program')}
          desc={session.get('testTypeFamily').get('shortDescription').toJS()}
        />
      )}
      <p className="account-session-heading__desc">
        <Trans>account.session.id</Trans> {session.get('id')}
      </p>
      {past && (
        <div className="account-session-heading__place">
          {session.get('testingSite') ? (
            <Address
              addressName={session.get('testingSite').get('name')}
              wheelchairAccess={session.get('testingSite').get('wheelchairAccess')}
              address={session.get('testingSite').get('address')}
            />
          ) : (
            <LocationTitle>
              <Trans>common.online</Trans>
            </LocationTitle>
          )}
        </div>
      )}

      {session.hasIn(['testType', 'scoreReport', 'url']) && (
        <Fragment>
          <Link onClick={() => setIsModalOpened(true)} aria-label={t('account.session.score-report-link')}>
            <Icon name={'arrow'} aria-label="modal-open-arrow-icon" role="img" />
            <Trans>account.session.score-report-link</Trans>
          </Link>
          <BaseModal isOpen={isModalOpened} onClose={() => setIsModalOpened(false)}>
            <img src={session.getIn(['testType', 'scoreReport', 'url'])} alt={'score_report'} />
          </BaseModal>
        </Fragment>
      )}
    </div>
  );
};

SessionHeading.propTypes = {
  session: instanceOf(Map).isRequired,
  past: bool.isRequired,
};

export default SessionHeading;
